import { render, staticRenderFns } from "./EventAddEditModal.vue?vue&type=template&id=7b650468&"
import script from "./EventAddEditModal.vue?vue&type=script&lang=js&"
export * from "./EventAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports